'use client'

import { useIsSticking } from '@repo/web-ui/hooks/use-is-sticking'
import * as React from 'react'

export function StickyComponentWatcher() {
  const [stickyVideoCta, setStickyVideoCta] = React.useState<HTMLDivElement | null>(null)
  const [stickyButtonCta, setStickyButtonCta] = React.useState<HTMLDivElement | null>(null)
  const isVideoCTAStuck = useIsSticking(stickyVideoCta, 30)

  React.useEffect(() => {
    setStickyVideoCta(document.querySelector('#sticky-cta-video') as HTMLDivElement)
    setStickyButtonCta(document.querySelector('#sticky-cta-button1') as HTMLDivElement)
  }, [])

  React.useEffect(() => {
    if (stickyButtonCta) {
      stickyButtonCta.style.opacity = isVideoCTAStuck ? '1' : '0'
    }
  }, [stickyButtonCta, isVideoCTAStuck])

  return null
}
